import React from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";

const About = () => {
  const x = useMotionValue(100);
  const y = useMotionValue(100);

  const rotateX = useTransform(y, [0, 200], [10, -10]);
  const rotateY = useTransform(x, [0, 200], [-10, 10]);

  return (
    // test
    <div className="w-screen h-screen ">
      <div className="flex flex-col relative h-screen text-center md:text-left md:flex-row  px-10 justify-center gap-20 mx-auto items-center z-20 ">
        <h3 className="absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl ">
          About
        </h3>

        <motion.div
          initial={{
            y: 100,
            opacity: 0,
          }}
          whileInView={{
            y: 0,
            opacity: 1,
          }}
          transition={{
            duration: 1,
          }}
        >
          <motion.div
            style={{
              rotateX: rotateX,
              rotateY: rotateY,
            }}
            className="mt-28 flex h-60 w-64 items-start justify-center md:h-96 md:w-96 relative"
          >
            <img
              src="https://res.cloudinary.com/atm1x/image/upload/v1689074778/mugshot_sinu8p.png"
              width={2464}
              height={2464}
              alt="about img"
              priority
              className="-mb-10 h-64 w-64 sm:drop-shadow-[0_0px_20px_#ffffff0f] flex-shrink-0 rounded-full object-cover text-[#ffffff5d] transition duration-700  ease-in-out md:mb-0 md:h-96 md:w-96 md:rounded-lg xl:scale-110"
            />
          </motion.div>
        </motion.div>

        <div className="space-y-6 px-0 md:px-3 flex items-center ">
          <motion.p
            initial={{
              x: 100,
            }}
            whileInView={{
              y: 0,
              x: 0,
            }}
            transition={{
              duration: 1,
            }}
            className="text-justify text-sm font-bold  antialiased sm:text-base sm:font-normal md:max-w-xl md:text-base  md:leading-7 xl:text-xl  xl:leading-8 pb-4 sm:mt-32 relative"
          >
            <span className="hover:text-[#F7AB0A] transition-all ease-in-out hover:scale-105 tracking-wide">
              Hii i&apos;m Bhupesh. here&apos;s little bit about me. I started
              my Software Engineering journey in may 2021. And the journey till
              now has been really awesome. I&apos;ve worked with both startup
              and large cooperation and Along the journey i worked with React
              JS, Next Js, Tailwind Css, Redux for state management, HTML, Css,
              Api-integration. I compleated by Bachelor of Science in
              Information Technology (B.Sc IT) Degree in the year 2021.
            </span>
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default About;
